/**
 * Which screens of THIS window hold unsaved work right now (cross-module X XWP-74). Fed by the shared
 * unsaved-changes guard (hooks/useUnsavedChangesGuard.js — every editor that can lose typed data
 * already declares its `dirty` there), read by « Retourner vers la fenêtre précédente »: a window that
 * still holds unsaved work is never closed by the return action (XD-246).
 */
const ecrans = new Set();

/** Declare a screen dirty; returns the function that withdraws it (call it on clean / unmount). */
export function declarerModifications() {
  const jeton = Symbol("modifications");
  ecrans.add(jeton);
  return () => ecrans.delete(jeton);
}

/** True while at least one screen of this window holds unsaved work. */
export function aDesModificationsNonEnregistrees() {
  return ecrans.size > 0;
}
